// src/pages/About.js
import React from 'react';
import './About.css';
import { 
  FaShieldAlt, 
  FaHistory, 
  FaUsers, 
  FaRocket, 
  FaMapMarkerAlt, 
  FaPhone, 
  FaEnvelope, 
  FaClock,
  FaAward,
  FaHandshake,
  FaLightbulb,
  FaHeart,
  FaCheckCircle,
  FaStar
} from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-background">
          <div className="hero-pattern"></div>
        </div>
        <div className="about-hero-content">
          <div className="hero-badge"> 
            <FaStar className="badge-icon" />
            <span>Desde 2014</span>
          </div>
          <h1>Sobre a G3 Rastreamento</h1>
          <p>Excelência em rastreamento e monitoramento veicular com tecnologia de ponta e atendimento premium</p>
          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">10+</span>
              <span className="stat-label">Anos de Experiência</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">1000+</span>
              <span className="stat-label">Clientes Satisfeitos</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Suporte</span>
            </div>
          </div>
        </div>
      </section>

      {/* Missão, Visão e Valores */}
      <section className="mission-section">
        <div className="section-header">
          <h2>Nossa Identidade</h2>
          <p>Conheça os pilares que fundamentam nossa empresa</p>
        </div>
        <div className="mission-container">
          <div className="mission-item">
            <div className="mission-icon">
              <FaRocket />
            </div>
            <h3>Missão</h3>
            <p>Proporcionar segurança e tranquilidade aos nossos clientes através de soluções tecnológicas inovadoras em rastreamento veicular, garantindo proteção total e monitoramento em tempo real.</p>
          </div>
          <div className="mission-item">
            <div className="mission-icon">
              <FaLightbulb />
            </div>
            <h3>Visão</h3>
            <p>Ser referência nacional em rastreamento veicular, reconhecida pela excelência em serviços, inovação tecnológica e compromisso inabalável com a segurança dos nossos clientes.</p>
          </div>
          <div className="mission-item">
            <div className="mission-icon">
              <FaHeart />
            </div>
            <h3>Valores</h3>
            <p>Comprometimento, Inovação, Segurança, Transparência, Excelência no atendimento e Responsabilidade social são os valores que guiam todas as nossas ações.</p>
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="features-section">
        <div className="section-header">
          <h2>Por que escolher a G3?</h2>
          <p>Descubra o que nos torna únicos no mercado</p>
        </div>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon-wrapper">
              <FaShieldAlt className="feature-icon" />
            </div>
            <h3>Segurança Garantida</h3>
            <p>Tecnologia de ponta em rastreamento e monitoramento 24/7, com sistema de alertas inteligentes e resposta imediata a emergências.</p>
            <div className="feature-benefits">
              <span><FaCheckCircle /> Monitoramento em tempo real</span>
              <span><FaCheckCircle /> Sistema de alertas</span>
              <span><FaCheckCircle /> Resposta emergencial</span>
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-icon-wrapper">
              <FaHistory className="feature-icon" />
            </div>
            <h3>Experiência Comprovada</h3>
            <p>Mais de uma década de atuação no mercado, com milhares de casos de sucesso e conhecimento profundo das necessidades dos clientes.</p>
            <div className="feature-benefits">
              <span><FaCheckCircle /> 10+ anos no mercado</span>
              <span><FaCheckCircle /> Casos de sucesso</span>
              <span><FaCheckCircle /> Conhecimento especializado</span>
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-icon-wrapper">
              <FaUsers className="feature-icon" />
            </div>
            <h3>Atendimento Premium</h3>
            <p>Suporte especializado e personalizado, com equipe treinada e disponível 24 horas por dia para atender todas as suas necessidades.</p>
            <div className="feature-benefits">
              <span><FaCheckCircle /> Suporte 24/7</span>
              <span><FaCheckCircle /> Equipe especializada</span>
              <span><FaCheckCircle /> Atendimento personalizado</span>
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-icon-wrapper">
              <FaRocket className="feature-icon" />
            </div>
            <h3>Inovação Constante</h3>
            <p>Sempre atualizados com as últimas tecnologias, investindo continuamente em pesquisa e desenvolvimento para oferecer o melhor.</p>
            <div className="feature-benefits">
              <span><FaCheckCircle /> Tecnologia atualizada</span>
              <span><FaCheckCircle /> P&D contínuo</span>
              <span><FaCheckCircle /> Soluções inovadoras</span>
            </div>
          </div>
        </div>
      </section>

      {/* História */}
      <section className="history-section">
        <div className="history-background">
          <div className="history-pattern"></div>
        </div>
        <div className="history-content">
          <div className="section-header light">
            <h2>Nossa História</h2>
            <p>Uma jornada de crescimento e inovação</p>
          </div>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-year">2014</div>
              <div className="timeline-content">
                <h4>Fundação</h4>
                <p>A G3 Rastreamento nasceu da necessidade de oferecer soluções eficientes em segurança veicular, com foco em tecnologia e inovação.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2017</div>
              <div className="timeline-content">
                <h4>Expansão</h4>
                <p>Ampliamos nossa atuação para todo o Estado do Ceará, consolidando nossa presença no mercado estadual.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2020</div>
              <div className="timeline-content">
                <h4>Inovação</h4>
                <p>Migramos nossa plataforma digital e aplicativo mobile para novo datacenter, revolucionando a experiência do cliente.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2024</div>
              <div className="timeline-content">
                <h4>Liderança</h4>
                <p>Nos tornamos referência no setor, com tecnologia de ponta, abrangência nacional e atendimento excepcional ao cliente.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2025</div>
              <div className="timeline-content">
                <h4>Novos Planos</h4>
                <p>Lançamos o Plano Moto +, unindo rastreamento 24h, assistência completa e benefícios exclusivos de oficina para motociclistas de todo o Ceará.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2026</div>
              <div className="timeline-content">
                <h4>Experiência Digital</h4>
                <p>Evoluímos nosso site e o fluxo de agendamento online, tornando mais simples contratar, instalar e acompanhar a proteção do veículo.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipe e Cultura */}
      <section className="team-section">
        <div className="section-header">
          <h2>Nossa Equipe</h2>
          <p>Profissionais dedicados e apaixonados por tecnologia</p>
        </div>
        <div className="team-grid">
          <div className="team-card">
            <div className="team-avatar">
              <FaUsers />
            </div>
            <h3>Equipe Técnica</h3>
            <p>Especialistas em tecnologia e desenvolvimento, sempre atualizados com as últimas inovações do mercado.</p>
          </div>
          <div className="team-card">
            <div className="team-avatar">
              <FaHandshake />
            </div>
            <h3>Atendimento</h3>
            <p>Profissionais treinados para oferecer o melhor suporte, com foco na satisfação total do cliente.</p>
          </div>
          <div className="team-card">
            <div className="team-avatar">
              <FaAward />
            </div>
            <h3>Qualidade</h3>
            <p>Equipe comprometida com a excelência, garantindo que cada serviço supere as expectativas.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;